import { Badge } from "@light-technology/components";
import { type Program } from "../../state/api.types";
import { compactFormatter } from "../../utilities/analyticsHelpers";
import { api } from "../../state/api";

type DeviceCountStat = {
  label: string;
  count: number;
  color: "success" | "warning" | "gray";
};

type DevicesCountProps = {
  program: Program;
};

export const DevicesCount = ({ program }: DevicesCountProps) => {
  const { data } = api.useGetProgramDeviceStatsQuery(program.uuid);

  const stats: DeviceCountStat[] = [
    { label: "Connected", count: data?.active ?? 0, color: "success" },
    {
      label: "Needs attention",
      count: data?.needs_attention ?? 0,
      color: "warning",
    },
    {
      label: "Not yet connected",
      count: data?.not_connected ?? 0,
      color: "gray",
    },
  ];

  return (
    <div className="rounded-xl border border-secondary p-3xl">
      <div className="flex flex-col gap-4xl">
        <div className="font-semibold text-secondary">Devices</div>
        <div className="flex flex-wrap gap-3xl">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-1 flex-col gap-2">
              <Badge size="sm" color={stat.color} type="pill-color">
                {stat.label}
              </Badge>
              <div className="font-mono text-2xl font-semibold">
                {compactFormatter.format(stat.count)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
